import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MethodOfPaymentTopBarComponent } from './method-of-payment-top-bar.component';
import { MatButtonModule } from '@angular/material/button';
import { RecordListBackButtonModule } from 'src/app/components/record-list-back-button/record-list-back-button.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [MethodOfPaymentTopBarComponent],
  exports: [MethodOfPaymentTopBarComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    RecordListBackButtonModule,
    RouterModule
  ]
})
export class MethodOfPaymentTopBarModule { }
